import { IGift } from "@smartrr/shared/entities/Gift";
import { IMailingAddressJson } from "@smartrr/shared/entities/MailingAddress";
import {
  DeliveryMethodType,
  SubscriptionDeliveryMethod,
  SubscriptionDeliveryMethodLocalDelivery,
  SubscriptionDeliveryMethodPickup,
  SubscriptionDeliveryMethodShipping,
} from "@smartrr/shared/shopifyGraphQL/api";
import { formatAddressInline, formatGiftingAddressInline } from "@smartrr/shared/utils/formatAddressInline";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";

export const getDeliveryMethodTitle = (
  deliveryMethod?: SubscriptionDeliveryMethod,
  trackingCompany?: string
): string => {
  if (!deliveryMethod) {
    return trackingCompany ?? "";
  }

  switch (deliveryMethod.__typename) {
    case "SubscriptionDeliveryMethodLocalDelivery": {
      return typedLocalize("delivery.local");
    }
    case "SubscriptionDeliveryMethodPickup": {
      return typedLocalize("delivery.pickup");
    }
    case "SubscriptionDeliveryMethodShipping": {
      return trackingCompany ?? deliveryMethod?.shippingOption?.title ?? typedLocalize("delivery.shipping");
    }
    default: {
      return trackingCompany ?? "";
    }
  }
};

export const getDeliveryMethodType = (deliveryMethod?: SubscriptionDeliveryMethod): DeliveryMethodType => {
  if (!deliveryMethod) {
    return DeliveryMethodType.Shipping;
  }
  switch (deliveryMethod.__typename) {
    case "SubscriptionDeliveryMethodLocalDelivery": {
      return DeliveryMethodType.Local;
    }
    case "SubscriptionDeliveryMethodPickup": {
      return DeliveryMethodType.PickUp;
    }
    default: {
      return DeliveryMethodType.Shipping;
    }
  }
};

export const getShippingAddress = (
  shippingAddress: IMailingAddressJson | undefined,
  deliveryMethod?: SubscriptionDeliveryMethod,
  gift?: IGift
) => {
  if (gift) {
    return formatGiftingAddressInline(gift.to);
  }

  const deliveryMethodType = getDeliveryMethodType(deliveryMethod);
  let address: string | undefined;

  switch (deliveryMethodType) {
    case DeliveryMethodType.Local: {
      address = formatAddressInline((deliveryMethod as SubscriptionDeliveryMethodLocalDelivery)?.address ?? "");
      break;
    }
    case DeliveryMethodType.PickUp: {
      address = formatAddressInline(
        (deliveryMethod as SubscriptionDeliveryMethodPickup)?.pickupOption?.location?.address ?? ""
      );
      break;
    }
    case DeliveryMethodType.Shipping: {
      address = formatAddressInline((deliveryMethod as SubscriptionDeliveryMethodShipping)?.address ?? "");
      break;
    }
    default: {
      address = formatAddressInline(shippingAddress);
      break;
    }
  }

  if (!address) {
    return formatAddressInline(shippingAddress);
  }

  return address;
};
